// extracted by mini-css-extract-plugin
export default {"address-sec":"Address_address-sec__qjsa5","address-form-trigger":"Address_address-form-trigger__JDArW"};